// Named exports (Recommended)

const brandNameHe = () => window.Config?.brand_Name_HE ;

export const ESIM_INFO_TEXT = `eSim הוא SIM דיגיטלי קטן במיוחד, שמובנה בתוך הסמארטפון ומאפשר לך להתחבר ל${brandNameHe()} באופן מייד, בלי הצורך בכרטיס SIM פיזי`;

export const SUPPORTED_DEVICES_TEXT = `Android: הגדרות > חיבורים > מנהל SIM > אם מופיעה האפשרות ל- "הוסף eSIM" - המכשיר תומך ב- eSIM

Apple: הגדרות > סלולרי > מנהל SIM > אם מופיעה האפשרות ל- "הוסף eSIM" - המכשיר תומך ב - eSIM.`;

export const CHANGE_TO_ESIM_WIFI = 'בזמן החלפת ה-SIM ל-eSIM חובה להיות מחובר ל-Wi-Fi';

export const CHANGE_TO_ESIM_WARNING = 'שימו לב! מיד לאחר האישור יש להפעיל את ה-eSIM (הוראות יישלחו במייל וב-SMS). SIM הפלסטיק יתבטל ולא יהיה ניתן לעשות בו שימוש';

export const CHANGE_TO_ESIM_SUPPORT = 'חשוב לוודא שהמכשיר תומך ב-eSIM';

export const CHANGE_TO_ESIM_SUCCESS_TEXT = 'יש להפעיל עכשיו את ה-eSIM באמצעות סריקת ברקוד או הזנת קודי הפעלה. הוראות ההפעלה נשלחו אליכם ב-SMS';
